/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum Creator {
    UNKNOWN = 'UNKNOWN',
    USER_WEBAPP = 'USER_WEBAPP',
    USER_PIP = 'USER_PIP',
    USER_PIP_LIGHTLY_MAGIC = 'USER_PIP_LIGHTLY_MAGIC',
    USER_WORKER = 'USER_WORKER'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const CreatorValidatorShape = [
    'UNKNOWN',
    'USER_WEBAPP',
    'USER_PIP',
    'USER_PIP_LIGHTLY_MAGIC',
    'USER_WORKER'
];
export const CreatorValidator = yup.mixed().oneOf(CreatorValidatorShape);
export const CreatorStringifyShapeProperties = {};
export const CreatorStringifyShape: StringSchema = {
    title: 'Creator Stringifier',
    type: 'string'
};
export const CreatorStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(CreatorStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function CreatorFromJSON(json: any): Creator {
    return CreatorFromJSONTyped(json, false);
}
export function CreatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Creator {
    return json as Creator;
}
export function CreatorToJSON(value?: Creator | null): any {
    return value as any;
}
